import { render } from "./PixFormDialog.vue?vue&type=template&id=6b2d5118&scoped=true"
import script from "./PixFormDialog.vue?vue&type=script&lang=js"
export * from "./PixFormDialog.vue?vue&type=script&lang=js"

import "./PixFormDialog.vue?vue&type=style&index=0&id=6b2d5118&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2d5118"]])

export default __exports__